/**
 * 住院管家相关路由
 */
export default [
  {
    path: '/manager/nav',
    component: () => import('Pages/manager/nav')
  },
  {
    path: '/manager/inhospital-records',
    name: 'inhospital-records',
    component: () => import('Pages/manager/inhospital-records')
  },
  {
    path: '/manager/payment-records',
    name: 'payment-records',
    component: () => import('Pages/manager/payment-records')

  },
  /**
   * 选择医院
   */
  {
    path: '/book/hos',
    meta: {
      title: '选择医院'
    },
    component: () => import('Pages/book/hos')
  },
  /**
   * 预约须知
   */
  {
    path: '/select/hos',
    meta: {
      title: '选择医院',
      keepAlive: true
    },
    component: () => import('Pages/book/bookTypeSelect')
  },
  /**
   * 一日清单
   * query
   * **** hosid
   * **** hosname
   */
  {
    path: '/manager/day-list',
    component: () => import('Pages/manager/day-list')
  },
  {
    path: '/manager/pay',
    component: () => import('Pages/manager/pay')
  },
]



// WEBPACK FOOTER //
// ./src/router/manager.js